// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-item-title[data-v-41ba9461]{font:normal bolder 16px Calibri;text-transform:uppercase;color:#00475a;white-space:normal}.router-link-active>div[data-v-41ba9461]{color:#fff;background-color:#6db7a2}.disclamer[data-v-41ba9461]{margin-top:10px;text-transform:uppercase;font-weight:bolder}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
